import { REFUND_REASON_TYPES } from "constants/refunds";
import { Sale } from "services/types/sales.type";
import { formatBackendDateOnly, formatMoney } from "utils/common";

export const getRefundsTableHtml = (sale: Sale) => {
  let result = `<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"><col style="width: 19.9864%;"></colgroup>
<tbody>
    <tr>
      <td><strong>Refunded At</strong></td>
      <td><strong>Sale Item</strong></td>
      <td><strong>Refund Amount</strong></td>
      <td><strong>Reason</strong></td>
      <td><strong>Description</strong></td>
    </tr>`;

  sale?.refunds?.forEach((refund) => {
    let row = `<td>${formatBackendDateOnly(
      refund.refunded_at,
      "MMMM dd, yyyy"
    )}</td>`;

    row = row + `<td>${refund?.sale_item?.description ?? ""}</td>`;

    row =
      row +
      `<td style="text-align: right">${formatMoney(
        Number(refund.amount),
        2
      )}</td>`;

    row = row + `<td>${REFUND_REASON_TYPES.getFromCode(refund.reason)}</td>`;

    row = row + `<td>${refund?.description ?? ""}</td>`;

    result = result + "<tr>" + row + "</tr>";
  });

  result =
    result +
    `<tr style="border: none">
      <td colspan="5"><br></td>
    </tr>`;

  result =
    result +
    `<tr style="border: none">
      <td colspan="3"><br></td>
      <td style="font-weight: 700">Refunds Total</td>
      <td style="font-weight: 700;text-align: right">${formatMoney(
        Number(sale.total_refunds)
      )}</td>
    </tr>`;

  result = result + `</tbody></table>`;
  return result;
};
